var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-popover",
        {
          ref: "pop",
          attrs: {
            placement: "right",
            title: _vm.icon,
            width: "300",
            trigger: "click"
          }
        },
        [
          _c("div", { staticClass: "icon-group" }, [
            _c("i", { class: "fa fa-" + _vm.icon })
          ]),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.iconClass,
                        placement: "top"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          on: {
                            click: function($event) {
                              return _vm.copy(_vm.iconClass)
                            }
                          }
                        },
                        [_vm._v("Class")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.iconHtml,
                        placement: "top"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          on: {
                            click: function($event) {
                              return _vm.copy(_vm.iconHtml)
                            }
                          }
                        },
                        [_vm._v("HTML")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        content: _vm.iconComponent,
                        placement: "top"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          on: {
                            click: function($event) {
                              return _vm.copy(_vm.iconComponent)
                            }
                          }
                        },
                        [_vm._v("组件")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          directives: [
            { name: "popover", rawName: "v-popover:pop", arg: "pop" }
          ]
        },
        [
          _c("el-tag", { staticClass: "icon-tag", attrs: { type: "info" } }, [
            _c("i", { class: "fa fa-" + _vm.icon })
          ]),
          _c("span", { staticStyle: { "font-size": "10px" } }, [
            _vm._v(_vm._s(_vm.icon))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }